import { render, staticRenderFns } from "./NoAdmBanner.vue?vue&type=template&id=5b45f64a&"
import script from "./NoAdmBanner.vue?vue&type=script&lang=js&"
export * from "./NoAdmBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports